import { Customer } from '@b2b/types/customer';
import { assertEvent, setup } from 'xstate';
import { CustomersIndividualsModalsMergeContext } from '../types';

type CustomersIndividualsModalsMergeEvents =
  | { type: 'CANCEL' }
  | { type: 'REVIEW' }
  | { type: 'BACK' }
  | { type: 'MERGE_CUSTOMERS' }
  | { type: 'MERGE_CUSTOMERS_SUCCESS'; result: Customer }
  | { type: 'MERGE_CUSTOMERS_FAILED' }
  | { type: 'DONE'; result: Customer };

export const customersIndividualsModalsMergeMachine = setup({
  types: {
    context: {} as CustomersIndividualsModalsMergeContext,
    events: {} as CustomersIndividualsModalsMergeEvents,
  },

  actions: {
    dismissModal: () => {},
    doneModal: (_, props: { result: Customer }) => {},
  },
}).createMachine({
  id: 'customersIndividualsModalsMerge',

  context: () => {
    return {};
  },

  initial: 'selecting_fields',

  states: {
    selecting_fields: {
      id: 'selecting_fields',
      on: {
        CANCEL: { actions: { type: 'dismissModal' } },
        REVIEW: { target: 'reviewing' },
      },
    },

    reviewing: {
      initial: 'idle',

      states: {
        idle: {
          on: {
            BACK: { target: '#selecting_fields' },
            MERGE_CUSTOMERS: { target: 'merging' },
          },
        },

        merging: {
          on: {
            MERGE_CUSTOMERS_SUCCESS: { target: 'done' },
            MERGE_CUSTOMERS_FAILED: { target: 'idle' },
          },
        },

        done: {
          type: 'final',
          entry: {
            type: 'doneModal',
            params: ({ event }) => {
              assertEvent(event, 'MERGE_CUSTOMERS_SUCCESS');

              return { result: event.result };
            },
          },
        },
      },
    },
  },
});
